/* global __OFFLINE_SW_URL__ */
// Registers the app-shell service worker (./sw.js, emitted by scripts/offline-sw-plugin.js) in
// production web builds and offers a reload when a new version is installed.
//
// Not in the Capacitor apps: their files are inside the app package already (offline from the
// start), iOS WKWebView does not run service workers for capacitor:// pages, and on Android a
// worker cache would keep serving the previous bundle after a store update. Offline data and the
// outbox (IndexedDB) work there all the same.
import React from "react";
import { Button, notification } from "antd";
import i18next from "i18next";
import { isNative } from "../native/platform";

const SW_URL = typeof __OFFLINE_SW_URL__ === "string" ? __OFFLINE_SW_URL__ : null;
const CHECK_EVERY_MS = 60 * 60 * 1000;
const t = key => i18next.t(key, { ns: "dashboard" });

let reloadRequested = false;

const offerReload = registration => {
  notification.info({
    key: "app-update",
    message: t("A new version is available"),
    description: t("Reload to use it. Changes waiting to be synced are kept."),
    duration: 0,
    placement: "bottomRight",
    btn: (
      <Button
        type="primary"
        size="small"
        onClick={() => {
          reloadRequested = true;
          notification.destroy("app-update");
          // The waiting worker takes over; controllerchange then reloads the page
          if (registration.waiting) registration.waiting.postMessage({ type: "SKIP_WAITING" });
          else window.location.reload();
        }}
      >
        {t("Reload")}
      </Button>
    )
  });
};

const watchForUpdates = registration => {
  if (registration.waiting && navigator.serviceWorker.controller) offerReload(registration);
  registration.addEventListener("updatefound", () => {
    const worker = registration.installing;
    if (!worker) return;
    worker.addEventListener("statechange", () => {
      // Without a controller this is the first install, not an update
      if (worker.state === "installed" && navigator.serviceWorker.controller) {
        offerReload(registration);
      }
    });
  });
  const check = () => {
    if (navigator.onLine) registration.update().catch(() => {});
  };
  setInterval(check, CHECK_EVERY_MS);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") check();
  });
};

export const registerServiceWorker = () => {
  if (!("serviceWorker" in navigator)) return;
  if (isNative) {
    // Never wanted in the app; remove one left behind by an earlier build
    navigator.serviceWorker
      .getRegistrations()
      .then(list => list.forEach(registration => registration.unregister()))
      .catch(() => {});
    return;
  }
  if (!SW_URL || process.env.NODE_ENV !== "production" || !window.isSecureContext) return;

  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (reloadRequested) window.location.reload();
  });
  const register = () =>
    navigator.serviceWorker
      .register(SW_URL, { scope: "/" })
      .then(watchForUpdates)
      .catch(error => console.warn("Service worker registration failed:", error));
  if (document.readyState === "complete") register();
  else window.addEventListener("load", register, { once: true });
};
